// extracted by mini-css-extract-plugin
export var image = "_if-0";